import cn from "classnames"

import {
  getDateFromSeconds,
  getDiffToNow,
  getRelativeTimeFromNow
} from "@/helpers/date.helpers"
import { useTranslation } from "@/hooks/useTranslation"
import { ClockCircleFilled } from "@/icons"
import { IssueDetails } from "@/molecules/IssueDetails"
import { KodemScore } from "@/molecules/KodemScoreCell"
import { Resources } from "@/molecules/Resources"

import styles from "./IssueCard.module.scss"

import type { IssueCardComponent } from "."

export const IssueCard: IssueCardComponent = (props) => {
  const { t } = useTranslation()
  const {
    issueType,
    cwe,
    riskId,
    resources,
    kodemScore,
    discoveredAt = 0,
    severity = "unknown"
  } = props
  const date = getDateFromSeconds(discoveredAt)
  const diffToNow = getDiffToNow(date) || 0
  const relativeDate = getRelativeTimeFromNow(date)

  return (
    <div
      className={cn("issue-card-widget-dashboard", styles.container)}
      onClick={() => props.onClick(props.id)}
    >
      <div className={styles.containerIssueDetails}>
        <IssueDetails
          issueId={props.id}
          t={t}
          title={cwe?.description || riskId || ""}
          description={
            <Resources
              inline
              popover
              resources={resources}
              t={t}
              onRowClick={props.onRowClick}
            />
          }
          severity={severity}
          issueType={issueType}
        />
      </div>
      <div className={styles.severityContainer}>
        <KodemScore score={kodemScore} />
      </div>
      <div className={styles.time}>
        {relativeDate && (
          <span
            style={{
              color: `var(--${diffToNow > 25 ? "dust-red-5" : "neutral-6"}-color)`
            }}
          >
            <ClockCircleFilled className={styles.clockIcon} />
            {relativeDate}
          </span>
        )}
      </div>
    </div>
  )
}
